import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FontAwesomeService } from '@services/font-awesome.service';
import {PrintSettingsEnum} from '@models/print.enum';

@Component({
  selector: 'app-printer-settings',
  templateUrl: './printer-settings.component.html',
  styleUrls: ['./printer-settings.component.scss']
})

export class PrinterSettingsComponent implements OnInit {
  @Input() printSettingsForm: FormGroup;
  public showPrinterFormat = false;
  public showZebraInstructions = false;

  constructor(public faService: FontAwesomeService) {
  }

  ngOnInit() {
    // this.togglePrinterFormat();
  }

  handlePrinterRadioChange(event) {
    if (event.value === PrintSettingsEnum.LABEL) {
      this.printSettingsForm.controls.unifaun_print_format.enable();
    } else {
      this.printSettingsForm.controls.unifaun_print_format.setValue(false);
      this.printSettingsForm.controls.unifaun_print_format.disable();
    }
  }

  toggleInstructions() {
    this.showZebraInstructions = !this.showZebraInstructions;
  }

  /*
  togglePrinterFormat() {
    const form = this.printSettingsForm.getRawValue();
    if (form.unifaun_account_type === 'PDF_NO_MARGIN') {
      this.showPrinterFormat = true;
    } else {
      this.showPrinterFormat = false;
    }
  }
  */

}



// WEBPACK FOOTER //
// ./src/app/modules/user-settings/printer-settings/printer-settings.component.ts